import React from 'react';

class CorrigirMovimentacaoForm extends React.Component {

    data(dt) {

        let vec = dt.split("-");
        let dia = vec[2];
        let mes = vec[1];
        let ano = vec[0];

        return dia + " / " + mes + " / " + ano;

    }

    ghg(g) {
        if (g) return "Sim";
        else return "Não";
    }

    render() {
        return(
            <div>
                <form id="corrmovimentacao-form">
                    <ul class="corrmovimentacao-ghg-lst">
                        <li>
                            <b>GHG: </b>
                            <span>{ this.ghg(this.props.ghg) }</span>
                        </li>
                    </ul><br />
                    <ul class="corrmovimentacao-ghg-lst">
                        <li>
                            <label>
                                <input type="radio"
                                    name="err_ghg"
                                    value="0"
                                    checked={ this.props.errGhg === 0 || this.props.errGhg === 3 }
                                    onChange={ this.props.changeErrGhg } /> Correto
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_ghg"
                                    value="1"
                                    checked={ this.props.errGhg === 1 }
                                    onChange={ this.props.changeErrGhg } /> Erro Simples
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_ghg"
                                    value="2"
                                    checked={ this.props.errGhg === 2 }
                                    onChange={ this.props.changeErrGhg } /> Erro Grave
                            </label>
                        </li>
                    </ul><br />
                    { (this.props.errGhg !== 0 && this.props.errGhg !== 3) &&
                        <ul class="corrmovimentacao-ghg-lst">
                            <li>
                                <b>GHG (Correção): </b>
                                <label>
                                    <input type="radio"
                                        name="ghg"
                                        value="true"
                                        checked={ this.props.corrGhg === true }
                                        onChange={ this.props.changeCorrGhg } /> Sim
                                </label>
                                <label>
                                    <input type="radio"
                                        name="ghg"
                                        value="false"
                                        checked={ this.props.corrGhg === false }
                                        onChange={ this.props.changeCorrGhg } /> Não
                                </label>
                            </li>
                        </ul> }
                    { (this.props.errGhg !== 0 && this.props.errGhg !== 3) && <br /> }
                    { (this.props.errGhg !== 0 && this.props.errGhg !== 3) && <br /> }
                    <br />
                    <span id="corrmovimentacao-data-span"><b>Data: </b>{ this.data(this.props.data) }</span>
                    <br /><br />
                    <ul class="corrmovimentacao-ghg-lst">
                        <li>
                            <label>
                                <input type="radio"
                                    name="err_data"
                                    value="0"
                                    checked={ this.props.errData === 0 || this.props.errData === 3 }
                                    onChange={ this.props.changeErrData } /> Correto
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_data"
                                    value="1"
                                    checked={ this.props.errData === 1 }
                                    onChange={ this.props.changeErrData } /> Erro Simples
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_data"
                                    value="2"
                                    checked={ this.props.errData === 2 }
                                    onChange={ this.props.changeErrData } /> Erro Grave
                            </label>
                        </li>
                    </ul><br />
                    { (this.props.errData !== 0 && this.props.errData !== 3) &&
                        <span id="corrmovimentacao-data-span"><b>Data (Correção): </b></span> }
                    { (this.props.errData !== 0 && this.props.errData !== 3) &&
                        <input type="date"
                            value={ this.props.corrData }
                            onChange={ this.props.changeCorrData } /> }
                    { (this.props.errData !== 0 && this.props.errData !== 3) && <br /> }
                    <br />
                    <span id="corrmovimentacao-nf-span"><b>Banco: </b>{ this.props.bancos[this.props.banco] }</span>
                    <br /><br />
                    <ul class="corrmovimentacao-ghg-lst">
                        <li>
                            <label>
                                <input type="radio"
                                    name="err_banco"
                                    value="0"
                                    checked={ this.props.errBanco === 0 || this.props.errBanco === 3 }
                                    onChange={ this.props.changeErrBanco } /> Correto
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_banco"
                                    value="1"
                                    checked={ this.props.errBanco === 1 }
                                    onChange={ this.props.changeErrBanco } /> Erro Simples
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_banco"
                                    value="2"
                                    checked={ this.props.errBanco === 2 }
                                    onChange={ this.props.changeErrBanco } /> Erro Grave
                            </label>
                        </li>
                    </ul><br />
                    { (this.props.errBanco !== 0 && this.props.errBanco !== 3) &&
                        <select id="corrmovimentacao-banco-select"
                            value={ this.props.corrBanco }
                            onChange={ this.props.changeCorrBanco }>
                            <option value="">Banco (Correção)</option>
                            { this.props.bancos.map((item, i) =>
                                <option key={ i } value={ i }>{ item }</option> ) }
                        </select> }
                    { (this.props.errBanco !== 0 && this.props.errBanco !== 3) && <br /> }
                    <br />
                    <span id="corrmovimentacao-nf-span"><b>Conta: </b>{ this.props.conta }</span>
                    <br /><br />
                    <span id="corrmovimentacao-nf-span">
                        <b>Código da Conta: </b>{ this.props.codConta }
                    </span>
                    <br /><br />
                    <span id="corrmovimentacao-nf-span">
                        <b>Código da Movimentação: </b>{ this.props.codMovimentacao }
                    </span>
                    <br /><br />
                    <ul class="corrmovimentacao-ghg-lst">
                        <li>
                            <label>
                                <input type="radio"
                                    name="err_conta"
                                    value="0"
                                    checked={ this.props.errConta === 0 || this.props.errConta === 3 }
                                    onChange={ this.props.changeErrConta } /> Correto
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_conta"
                                    value="1"
                                    checked={ this.props.errConta === 1 }
                                    onChange={ this.props.changeErrConta } /> Erro Simples
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_conta"
                                    value="2"
                                    checked={ this.props.errConta === 2 }
                                    onChange={ this.props.changeErrConta } /> Erro Grave
                            </label>
                        </li>
                    </ul><br />
                    { (this.props.errConta !== 0 && this.props.errConta !== 3) &&
                        <select value={ this.props.corrConta } onChange={ this.props.changeCorrConta }>
                            <option value="">Conta (Correção)</option>
                            { this.props.contas.map((item, i) =>
                                <option key={ i } value={ i }>{ item.cod_conta + " - " + item.conta }</option> ) }
                        </select> }
                    { (this.props.errConta !== 0 && this.props.errConta !== 3) && <br /> }
                    { (this.props.errConta !== 0 && this.props.errConta !== 3) &&
                        <input type="text"
                            placeholder="Código da Conta (Correção)"
                            value={ this.props.corrCodConta }
                            disabled /> }
                    { (this.props.errConta !== 0 && this.props.errConta !== 3) && <br /> }
                    { (this.props.errConta !== 0 && this.props.errConta !== 3) &&
                        <input type="text"
                            placeholder="Código da Movimentação (Correção)"
                            value={ this.props.corrCodMovimentacao }
                            disabled /> }
                    { (this.props.errConta !== 0 && this.props.errConta !== 3) && <br /> }
                    <br />
                    <span id="corrmovimentacao-nf-span"><b>Histórico: </b>{ this.props.historico }</span>
                    <br /><br />
                    <ul class="corrmovimentacao-ghg-lst">
                        <li>
                            <label>
                                <input type="radio"
                                    name="err_historico"
                                    value="0"
                                    checked={ this.props.errHistorico === 0 || this.props.errHistorico === 3 }
                                    onChange={ this.props.changeErrHistorico } /> Correto
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_historico"
                                    value="1"
                                    checked={ this.props.errHistorico === 1 }
                                    onChange={ this.props.changeErrHistorico } /> Erro Simples
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_historico"
                                    value="2"
                                    checked={ this.props.errHistorico === 2 }
                                    onChange={ this.props.changeErrHistorico } /> Erro Grave
                            </label>
                        </li>
                    </ul><br />
                    { (this.props.errHistorico !== 0 && this.props.errHistorico !== 3) &&
                        <input type="text"
                            placeholder="Histórico (Correção)"
                            value={ this.props.corrHistorico }
                            onChange={ this.props.changeCorrHistorico } /> }
                    { (this.props.errHistorico !== 0 && this.props.errHistorico !== 3) && <br /> }
                    <br />
                    <span id="corrmovimentacao-nf-span">
                        <b>Descrição da Movimentação: </b>{ this.props.descricao }
                    </span>
                    <br /><br />
                    <ul class="corrmovimentacao-ghg-lst">
                        <li>
                            <label>
                                <input type="radio"
                                    name="err_descricao"
                                    value="0"
                                    checked={ this.props.errDescricao === 0 || this.props.errDescricao === 3 }
                                    onChange={ this.props.changeErrDescricao } /> Correto
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_descricao"
                                    value="1"
                                    checked={ this.props.errDescricao === 1 }
                                    onChange={ this.props.changeErrDescricao } /> Erro Simples
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_descricao"
                                    value="2"
                                    checked={ this.props.errDescricao === 2 }
                                    onChange={ this.props.changeErrDescricao } /> Erro Grave
                            </label>
                        </li>
                    </ul><br />
                    { (this.props.errDescricao !== 0 && this.props.errDescricao !== 3) &&
                        <textarea placeholder="Descrição da Movimentação (Correção)"
                            value={ this.props.corrDescricao }
                            onChange={ this.props.changeCorrDescricao }></textarea> }
                    { (this.props.errDescricao !== 0 && this.props.errDescricao !== 3) && <br /> }
                    <br />
                    <span Class="corrmovimentacao-somente-numeros">
                        (Somente valores númericos no campo de Valor.)
                    </span><br /><br />
                    <span id="corrmovimentacao-nf-span"><b>Valor (R$): </b>{ this.props.valor }</span>
                    <br /><br />
                    <ul class="corrmovimentacao-ghg-lst">
                        <li>
                            <label>
                                <input type="radio"
                                    name="err_valor"
                                    value="0"
                                    checked={ this.props.errValor === 0 || this.props.errValor === 3 }
                                    onChange={ this.props.changeErrValor } /> Correto
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_valor"
                                    value="1"
                                    checked={ this.props.errValor === 1 }
                                    onChange={ this.props.changeErrValor } /> Erro Simples
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_valor"
                                    value="2"
                                    checked={ this.props.errValor === 2 }
                                    onChange={ this.props.changeErrValor } /> Erro Grave
                            </label>
                        </li>
                    </ul><br />
                    { (this.props.errValor !== 0 && this.props.errValor !== 3) &&
                        <input type="text"
                            placeholder="Valor (R$) (Correção)"
                            value={ this.props.corrValor }
                            onChange={ this.props.changeCorrValor } /> }
                    { (this.props.errValor !== 0 && this.props.errValor !== 3) && <br /> }
                    <br />
                    <span id="corrmovimentacao-nf-span">
                        <b>Documento Fiscal: </b>{ this.props.notaFiscal }
                    </span><br /><br />
                    <ul class="corrmovimentacao-ghg-lst">
                        <li>
                            <label>
                                <input type="radio"
                                    name="err_nota_fiscal"
                                    value="0"
                                    checked={ this.props.errNotaFiscal === 0 || this.props.errNotaFiscal === 3 }
                                    onChange={ this.props.changeErrNotaFiscal } /> Correto
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_nota_fiscal"
                                    value="1"
                                    checked={ this.props.errNotaFiscal === 1 }
                                    onChange={ this.props.changeErrNotaFiscal } /> Erro Simples
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_nota_fiscal"
                                    value="2"
                                    checked={ this.props.errNotaFiscal === 2 }
                                    onChange={ this.props.changeErrNotaFiscal } /> Erro Grave
                            </label>
                        </li>
                    </ul><br />
                    { (this.props.errNotaFiscal !== 0 && this.props.errNotaFiscal !== 3) && 
                        <span id="corrmovimentacao-nf-span"><b>Comprovante Fiscal (Correção): </b></span> }
                    { (this.props.errNotaFiscal !== 0 && this.props.errNotaFiscal !== 3) &&
                        <input type="file"
                            id="corrmovimentacao-nf-file"
                            onChange={ this.props.changeCorrNotaFiscal }
                            accept="application/pdf, image/jpeg, image/png, application/xml" /> }
                    { (this.props.errNotaFiscal !== 0 && this.props.errNotaFiscal !== 3) && <br /> }
                    { (this.props.errNotaFiscal !== 0 && this.props.errNotaFiscal !== 3) && <br /> }
                    <br />
                    <span id="corrmovimentacao-nf-span">
                        <b>Comprovante de Pagamento: </b>{ this.props.comprovante }
                    </span><br /><br />
                    <ul class="corrmovimentacao-ghg-lst">
                        <li>
                            <label>
                                <input type="radio"
                                    name="err_comprovante"
                                    value="0"
                                    checked={ this.props.errComprovante === 0 || this.props.errComprovante === 3 }
                                    onChange={ this.props.changeErrComprovante } /> Correto
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_comprovante"
                                    value="1"
                                    checked={ this.props.errComprovante === 1 }
                                    onChange={ this.props.changeErrComprovante } /> Erro Simples
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_comprovante"
                                    value="2"
                                    checked={ this.props.errComprovante === 2 }
                                    onChange={ this.props.changeErrComprovante } /> Erro Grave
                            </label>
                        </li>
                    </ul><br />
                    { (this.props.errComprovante !== 0 && this.props.errComprovante !== 3) && 
                        <span id="corrmovimentacao-nf-span"><b>Comprovante de Pagamento (Correção): </b></span> }
                    { (this.props.errComprovante !== 0 && this.props.errComprovante !== 3) &&
                        <input type="file"
                            id="corrmovimentacao-nf-file"
                            onChange={ this.props.changeCorrComprovante }
                            accept="application/pdf, image/jpeg, image/png, application/xml" /> }
                    { (this.props.errComprovante !== 0 && this.props.errComprovante !== 3) && <br /> }
                    { (this.props.errComprovante !== 0 && this.props.errComprovante !== 3) && <br /> }
                    <br />
                    <span id="corrmovimentacao-nf-span">
                        <b>Análise Contábil: </b>{ this.props.analiseContabil }
                    </span>
                    <br /><br />
                    <ul class="corrmovimentacao-ghg-lst">
                        <li>
                            <label>
                                <input type="radio"
                                    name="err_analise_contabil"
                                    value="0"
                                    checked={ this.props.errAnaliseContabil === 0 || this.props.errAnaliseContabil === 3 }
                                    onChange={ this.props.changeErrAnaliseContabil } /> Correto
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_analise_contabil"
                                    value="1"
                                    checked={ this.props.errAnaliseContabil === 1 }
                                    onChange={ this.props.changeErrAnaliseContabil } /> Erro Simples
                            </label>
                            <label>
                                <input type="radio"
                                    name="err_analise_contabil"
                                    value="2"
                                    checked={ this.props.errAnaliseContabil === 2 }
                                    onChange={ this.props.changeErrAnaliseContabil } /> Erro Grave
                            </label>
                        </li>
                    </ul><br />
                    { (this.props.errAnaliseContabil !== 0 && this.props.errAnaliseContabil !== 3) &&
                        <textarea placeholder="Análise Contábil (Correção)"
                            value={ this.props.corrAnaliseContabil }
                            onChange={ this.props.changeCorrAnaliseContabil }></textarea> }
                    { (this.props.errAnaliseContabil !== 0 && this.props.errAnaliseContabil !== 3) && <br /> }
                    <br />
                    <button type="button" id="corrmovimentacao-corrigir-btn" onClick={ this.props.corrigir }>
                        Corrigir
                    </button>
                    <button type="button" id="corrmovimentacao-cancelar-btn" onClick={ this.props.cancelar }>
                        Cancelar
                    </button>
                    <br /><br />
                </form>
            </div>
        );
    }

}

export default CorrigirMovimentacaoForm;

